import { reloadEpic } from './state/reload.epic';

export const transcriptImportDialogEpics = [reloadEpic];
